import template from './general_document_categories.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeDocumentType
{
	constructor(config)
	{
		let data = Object.assign({
			type: '',
			default_viewing_roles: ['admin'],
			edit_mode: false
		}, config);

		ko.mapping.fromJS(data, {}, this);

		this.type = ko.observable(data.type);
		this.type.subscribe((value) => {
			if (value != '')
				window.document.getElementById('warning-empty').style.display = 'none';
		});
	}
}

class AdminGeneralDocumentCategoriesViewModel
{
	constructor(page)
	{
		this.page = page;
		this.general_document_types = ko.observableArray();
		this.access_roles = ko.observableArray();
		this.editing = ko.observable(false);
		window.current_page_title(tr('Add/Edit Company Document Categories'));
	}

	async toggle_edit_mode(v, e)
	{
		this.editing(!this.editing());
		if (v.edit_mode()) 
			await this.page.updateData(); 
		v.edit_mode(!v.edit_mode());
	}

	add_document_type()
	{
		let employee_doc_type = new EmployeeDocumentType();
		employee_doc_type.edit_mode(true);
		this.general_document_types.unshift(employee_doc_type);
		this.editing(true);
	}

	async delete_document_type(v, e)
	{
		let data = ko.mapping.toJS(v);

		delete data.edit_mode;
		let response = await Grape.alerts.confirm({
			type: 'warning',
			title: tr('Warning'),
			message: tr('Are you sure you want to delete this document type?')
		});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/general_document_types/delete', data);
			Utils.wrap_api_result(res, tr, async () => {
				Grape.alerts.alert({ type: 'success', title: tr('Success'), message: tr('Successfully deleted document type.')});
				await this.page.updateData();
			});
		}
	}

	async save_document_type(v, e)
	{
		let data = ko.mapping.toJS(v);

		if (data.type === '')
			window.document.getElementById('warning-empty').style.display = 'block';
		else
		{
			window.document.getElementById('warning-empty').style.display = 'none';
			delete data.edit_mode;

			if (!data.general_document_type_id)
			{
					let res = await Grape.fetches.postJSON('/admin/general_document_types/edit', data);
					Utils.wrap_api_result(res, tr, async () => {
						Grape.alerts.alert({type: 'success', title: tr('Success'), message: tr('Successfully saved document type.')});
						await this.page.updateData();
					});
					return; 
			} 

			let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Do you want to bulk update the roles for this document type? Doing that will update the viewing roles of the documents that are already uploaded under this category.') });

			if (response)
				data.bulk_update_viewing_roles = true;

			let res = await Grape.fetches.postJSON('/admin/general_document_types/edit', data);
			Utils.wrap_api_result(res, tr, async() => {
				await Grape.alerts.alert({ type: 'success', title: tr('Success'), message: tr('Successfully saved document type.') });
				await this.page.updateData();
			});
		}
	}

	show_employee_documents_help()
	{
		Grape.dialog.open('GeneralDocumentsHelp', {});
	}
}

class AdminGeneralDocumentCategoriesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminGeneralDocumentCategoriesViewModel(this);
	}

	async init()
	{
		document.title = tr('Manage Company Document Categories');

		this.viewModel.access_roles(await Grape.cache.get('AccessRoleLookup') || []);

		// TODO: Confirm is this necessary? - Specific role exclusions
		this.viewModel.access_roles.remove('unverified user');
	}

	async updateData()
	{
		try {
			let options = {
				table: 'general_document_types',
				schema: 'public',
				sortfield: 'general_document_type_id'
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status != 'ERROR')
			{
				let edt = res.records || [];
				edt = edt.map((e) => { return new EmployeeDocumentType(e); });
				this.viewModel.general_document_types(edt);
			}
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		this.viewModel.editing(false);
		Utils.refresh_data_visible_roles(); // TODO: Confirm is this necessary?
	}
};

export default {
	route: '[/]admin/general_document_categories',
	page_class: AdminGeneralDocumentCategoriesPage,
	template: template,
	template_filename: 'translation/general_document_categories'
};
